model_provider = "{{providerId}}"
{{#forcedLoginMethod}}
forced_login_method = "{{forcedLoginMethod}}"
{{/forcedLoginMethod}}
{{#model}}
model = "{{{model}}}"
{{/model}}
{{#reasoningEffort}}
model_reasoning_effort = "{{reasoningEffort}}"
{{/reasoningEffort}}

{{#model}}
[profiles."{{{profileName}}}"]
model = "{{{model}}}"
model_provider = "{{providerId}}"
{{#reasoningEffort}}
model_reasoning_effort = "{{reasoningEffort}}"
{{/reasoningEffort}}

{{/model}}
{{^codexBuiltInProvider}}
[model_providers.{{providerId}}]
name = "{{providerId}}"
base_url = "{{{baseUrl}}}"
wire_api = "responses"
experimental_bearer_token = "{{apiKey}}"
requires_openai_auth = false
supports_websockets = false
{{/codexBuiltInProvider}}
